import { ApolloClient, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { getTokenString } from '../common/auth';

import { cache } from './cache';
import createErrorLink from './errorLink';

export type AuthClient = ApolloClient<unknown>;

export default async function createClient(graphqlUri: string, ssoUrl: string): Promise<AuthClient> {
  const httpLink = createHttpLink({
    uri: graphqlUri,
    credentials: 'same-origin',
  });

  const authLink = setContext(() => {
    const token = getTokenString();
    return {
      headers: {
        authorization: token ? `Bearer ${token}` : undefined,
      },
    };
  });

  const errorLink = createErrorLink(ssoUrl);

  const client: ApolloClient<unknown> = new ApolloClient({
    cache,
    link: from([errorLink, authLink, httpLink]),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: true,
      },
    },
  });
  return client;
}
